export enum ImportWarningType {
    None = 'None',
    SoftDeleted = 'SoftDeleted',
    ContractTransition = 'ContractTransition',
    NewDictionaryEntry = 'NewDictionaryEntry',
    UnknownDictionaryCode = 'UnknownDictionaryCode',
    MissingEmail = 'MissingEmail',
    DuplicateEmail = 'DuplicateEmail',
}

export enum ImportErrorType {
    None = 'None',
    ParseError = 'ParseError',
    MissingRequiredField = 'MissingRequiredField',
    EnovaCodeConflict = 'EnovaCodeConflict',
    RehireConflict = 'RehireConflict',
    UnexpectedError = 'UnexpectedError',
}

export interface ImportWarning {
    type: ImportWarningType;
    message: string;
}

export interface ImportError {
    rowNumber: number;
    message: string;
}

export interface SkippedEmployeeEntry {
    identity: string;
    rows: { rowNumber: number }[];
}

export interface ImportResultDto {
    employeesCreated: number;
    employeesUpdated: number;
    employeesSkipped: number;
    employeesFailed: number;
    employeesSoftDeleted: number;
    allocationsOpened: number;
    allocationsClosed: number;
    allocationsUnchanged: number;
    dictionariesCreated: number;
    skippedEmployees: SkippedEmployeeEntry[];
    warnings: ImportWarning[];
    errors: ImportError[];
}

// Numeric to match the backend enum — no global StringEnumConverter is registered in Startup.cs.
export enum ImportHistoryStatus {
    None = 0,
    Available = 1,
    StorageNotConfigured = 2,
    StorageUnavailable = 3,
}

export interface ImportHistoryEntryDto {
    importedAt: string;
    result: ImportResultDto;
}

export interface ImportHistoryDto {
    status: ImportHistoryStatus;
    entries: ImportHistoryEntryDto[];
}

export enum EmployeeDictionaryType {
    CostCenter = 1,
    Project = 2,
    WorkSchedule = 3,
    Position = 4,
    ContractType = 5,
}

export interface EmployeeDictionaryEntryDto {
    id: number;
    code: string;
    displayName: string;
    isActive: boolean;
}

export interface UpdateDictionaryEntryRequest {
    displayName: string;
    isActive: boolean;
}

export interface AddDictionaryEntryRequest {
    code: string;
    displayName: string;
}
